// ====================================================================================================================
// 画面パス関連定義
//
// /main[/sub][/id][/mode][/query]
// ====================================================================================================================

const keyworkDefs = {
  main: {
    ROOT: '/outsource-member-report',
    WORK_CONTENT: 'work-content',
    WORK_REPORT: 'work-report',
    SUCCEEDED: '/success',
    HELP: 'help',
    ERROR: 'error',
  },
  sub: {},
  mode: {
    EDIT: 'edit',
    VIEW: 'view',
  },
} as const;

/**
 * 画面識別子
 */
export type PageMainId = keyof typeof keyworkDefs.main;
/**
 * 画面パス (main)
 */
export type PageMain = (typeof keyworkDefs.main)[PageMainId];
/**
 * 画面パス定義 (main)
 */
const PageMainDef: Record<PageMainId, PageMain> = keyworkDefs.main;

/**
 * サブ画面識別子
 */
export type PageSubId = keyof typeof keyworkDefs.sub;
/**
 * 画面パス (sub)
 */
export type PageSub = (typeof keyworkDefs.sub)[PageSubId];
/**
 * 画面パス定義 (sub)
 */
const PageSubDef: Record<PageSubId, PageSub> = keyworkDefs.sub;

/**
 * モード識別子
 */
export type ModeId = keyof typeof keyworkDefs.mode;
/**
 * 画面モード (mode)
 */
export type PageParamMode = (typeof keyworkDefs.mode)[ModeId];
/**
 * 画面モード定義 (mode)
 */
const PageModeDef: Record<ModeId, PageParamMode> = keyworkDefs.mode;

/**
 * 画面キーワード定義
 */
export const pageKeywords: {
  main: Record<PageMainId, PageMain>;
  sub: Record<PageSubId, PageSub>;
  mode: Record<ModeId, PageParamMode>;
} = keyworkDefs;

// ================
// 画面
// ================
/**
 * 画面パス
 */
const pages = {
  ROOT: PageMainDef.ROOT,
  WORK_CONTENT: `${PageMainDef.ROOT}/${PageMainDef.WORK_CONTENT}`,
  WORK_REPORT: `${PageMainDef.ROOT}/${PageMainDef.WORK_REPORT}`,
  SUCCEEDED: PageMainDef.SUCCEEDED,
} as const;

/**
 * 画面識別子
 */
export type Pages = keyof typeof pages;
export const pagePaths = pages;

/**
 * 画面名
 */
export const pageNames: Record<Pages, string> = {
  ROOT: '外注メンバ報告',
  WORK_CONTENT: '就業内容',
  WORK_REPORT: '作業報告書',
  SUCCEEDED: '報告完了',
} as const;
